import { render, staticRenderFns } from "./BorderCard.vue?vue&type=template&id=1d6cb1a1&scoped=true&"
import script from "./BorderCard.vue?vue&type=script&lang=ts&"
export * from "./BorderCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6cb1a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VSheet})
